import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { CircleDollarSign, Scale, ServerCog, Handshake, TrendingUp, ShieldCheck } from 'lucide-react';

const icons = [CircleDollarSign, Scale, ServerCog, Handshake, TrendingUp, ShieldCheck];

export const ProgramsSection = () => {
  const { language, t } = useLanguage();
  return (
    <section id="programs" className="section-padding bg-[#F5F8FB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`max-w-4xl ${language === 'ar' ? 'ml-auto text-right' : ''}`}>
          <span className="inline-block text-sm uppercase tracking-[0.14em] font-bold text-[#B78321] mb-4">{t.capabilities.eyebrow}</span>
          <h2 className="text-3xl sm:text-5xl font-bold text-slate-900 leading-tight">{t.capabilities.title}</h2>
        </div>
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.capabilities.items.map(([title,body],index) => {
            const Icon = icons[index];
            return (
              <article key={title} className={`rounded-2xl bg-white border border-slate-200 p-6 shadow-sm hover:shadow-md transition-shadow ${language === 'ar' ? 'text-right' : ''}`}>
                <div className={`w-12 h-12 rounded-xl bg-[#0B4DA2]/10 flex items-center justify-center mb-5 ${language === 'ar' ? 'mr-auto' : ''}`}>
                  <Icon className="w-6 h-6 text-[#0B4DA2]" />
                </div>
                <h3 className="text-xl font-bold text-slate-900">{title}</h3>
                <p className="mt-3 text-slate-600 leading-relaxed">{body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
